"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var pick = function pick(object, keys) {
  return Object.keys(object).filter(function (key) {
    return keys.includes(key);
  }).reduce(function (acculumatedObject, key) {
    return Object.assign({}, acculumatedObject, (0, _defineProperty2.default)({}, key, object[key]));
  }, {});
};

var _default = pick;
exports.default = _default;
module.exports = exports.default;